export default function DaytonaServicesSection() {
  return (
    <section id="services" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Services</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">Passport Services for Daytona Beach</h2>
          <p className="text-gray-500 max-w-xl mx-auto text-base">Fast Passport Center serves Daytona Beach, Port Orange, Ormond Beach, and all Volusia County travelers.</p>
        </div>
        <p className="text-center text-gray-400 text-sm">Complete list of services available on our main site.</p>
      </div>
    </section>
  );
}